import {
  getMappedBuildingOptions,
  getMappedCategoryOptions,
} from '../../../api'
import {
  PAGINATION_ALL_ITEMS_SIZE,
  PAGINATION_PAGE_SIZE_PARAM,
} from '../../../constants/pagination'

export function getAllMappedCategoryOptions(params) {
  return getMappedCategoryOptions({
    ...params,
    [PAGINATION_PAGE_SIZE_PARAM]: PAGINATION_ALL_ITEMS_SIZE,
  })
}

export function getAllMappedBuildingOptions(params) {
  return getMappedBuildingOptions({
    ...params,
    [PAGINATION_PAGE_SIZE_PARAM]: PAGINATION_ALL_ITEMS_SIZE,
  })
}
